import { useEffect, useState } from "react"
import LoadingSpinner from '../../Spinner';
import { Flip, ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "./../toastify/config";
import apiCumbres from "../../axios/axios";
import { motion } from "motion/react";
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, } from "@mui/material";
import { styleBtn,  sxTableHead,  textFieldStyle } from "../Styles";

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';


const ContratosPagos = () => {

    const [isLoading, setIsLoading] = useState(false)
    const [fechaDesdeReporte, setFechaDesdeReporte] = useState(null)
    const [fechaHastaReporte, setFechaHastaReporte] = useState(null)
    const [buscar, setBuscar] = useState(false)

    const [cantidadPrestada, setCantidadPrestada] = useState(0)
    const [pagosCapital, setPagosCapital] = useState(0)
    const [pagosInteres, setPagosInteres] = useState(0)
    const [pagosTotal, setPagosTotal] = useState(0)
    const [pagosMora, setPagosMora] = useState(0)
    


    const buscarInformacion = () => {

        setBuscar(false)


        const obtener = async () => {

            try {
                setIsLoading(true)
                const jReporteCp = {
                    fechaHastaReporte,
                    fechaDesdeReporte
                }

                const obteniendo = await apiCumbres.post('/reportes/contratos-pagos/obtener', jReporteCp)

                setCantidadPrestada(obteniendo.data.cantidadPrestada)
                setPagosCapital(obteniendo.data.pagosCapital)
                setPagosInteres(obteniendo.data.pagosInteres)
                setPagosTotal(obteniendo.data.pagosTotal)
                setPagosMora(obteniendo.data.pagosMora)

                setBuscar(true)
                setIsLoading(false)

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    console.log(error.response)
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al obtener información de contratos-pagos, favor de volver a intentarlo!'
                    }
                } else {
                    console.log(error)
                    msg_error = 'No hay respuesta por parte del servidor!'
                }
                //mensaje de toastify
                setIsLoading(false)
                setBuscar(false)
                toast.error(msg_error, toast_config)
            }

        }

        obtener()


    }

    const formatNumber = (value) => {
        const [intPart, decimalPart] = value.split('.');

        const formattedInt = parseInt(intPart, 10).toLocaleString('en-US');
        return decimalPart !== undefined ? `${formattedInt}.${decimalPart}` : formattedInt;
    };

    useEffect(() => {
        if (
            fechaDesdeReporte &&
            fechaHastaReporte &&
            fechaDesdeReporte.isAfter(fechaHastaReporte)
        ) {
            setFechaHastaReporte(null);
        }
    }, [fechaDesdeReporte]);
    
    useEffect(() => {
        if (
            fechaDesdeReporte &&
            fechaHastaReporte &&
            fechaHastaReporte.isBefore(fechaDesdeReporte)
        ) {
            setFechaDesdeReporte(null);
        }
    }, [fechaHastaReporte]);


    return (
        <>
            <div className="container">
                {isLoading ?
                    <LoadingSpinner />
                    : null}

                <div className="row">
                    <motion.div
                        className="col-md-6 mb-3"
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5, ease: "easeOut", delay: 0.2 }}
                    >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Seleccionar Fecha Desde"
                                value={fechaDesdeReporte}
                                maxDate={fechaHastaReporte || undefined}
                                onChange={(newValue) => setFechaDesdeReporte(newValue)}
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        variant: "outlined",
                                        sx: { textFieldStyle },
                                    },
                                }}
                            />
                        </LocalizationProvider>

                    </motion.div>

                    <motion.div
                        className="col-md-6 mb-3"
                        initial={{ opacity: 0, x: 50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5, ease: "easeOut", delay: 0.3 }}
                    >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Seleccionar Fecha Hasta"
                                value={fechaHastaReporte}
                                minDate={fechaDesdeReporte || undefined}
                                onChange={(newValue) => setFechaHastaReporte(newValue)}
                                slotProps={{
                                    textField: {
                                        fullWidth: true,
                                        variant: "outlined",
                                        sx: { textFieldStyle },
                                    },
                                }}
                            />
                        </LocalizationProvider>

                    </motion.div>

                    <motion.div
                        className="col-md-12 mt-3"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, ease: "easeOut", delay: 0.4 }}
                        whileHover={{
                            y: -4,
                            scale: 1.03,
                            filter: "brightness(1.1)",
                            transition: { duration: 0.25, ease: "easeOut" },
                        }}
                    >
                        <Button variant="contained" fullWidth sx={styleBtn} onClick={buscarInformacion} >
                            Buscar
                        </Button>
                    </motion.div>

                    {buscar &&
                        <motion.div
                            className="col-md-12 mt-3"
                            initial={{ opacity: 0, y: 50 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, ease: "easeOut", delay: 0.1 }}
                        >
                            <TableContainer component={Paper} sx={{ mt: 2, mb: 3 }}>
                                <Table>
                                    <TableHead>
                                        <TableRow sx={{ backgroundColor: "#0a2540" }}>
                                            <TableCell sx={sxTableHead}>Cantidad Prestada</TableCell>
                                            <TableCell sx={sxTableHead}>Abonos a Capital</TableCell>
                                            <TableCell sx={sxTableHead}>Abonos a Interes</TableCell>
                                            <TableCell sx={sxTableHead}>Abonos Total</TableCell>
                                            <TableCell sx={sxTableHead}>Mora</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        <motion.tr
                                            initial={{ opacity: 0, x: -50 }}
                                            animate={{ opacity: 1, x: 0 }}
                                            exit={{ opacity: 0, y: -40 }}
                                            transition={{
                                                duration: 0.4,
                                                ease: "easeOut",
                                                delay: 0.1
                                            }}
                                            style={{
                                                backgroundColor: "#f9f9f9"
                                            }}
                                        >
                                            <TableCell>${formatNumber(cantidadPrestada)}</TableCell>
                                            <TableCell>${formatNumber(pagosCapital)}</TableCell>
                                            <TableCell>${formatNumber(pagosInteres)}</TableCell>
                                            <TableCell>${formatNumber(pagosTotal)}</TableCell>
                                            <TableCell>${formatNumber(pagosMora)}</TableCell>
                                        </motion.tr>

                                    </TableBody>
                                </Table>

                            </TableContainer>
                        </motion.div>

                    }


                </div>

                <ToastContainer
                    transition={Flip}
                    position="bottom-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="colored" />

            </div>

        </>
    )

}

export default ContratosPagos